import WrapperIonModal from "../../../../Components/ionic/WrapperIonModal";
import get from "lodash/get";
import {IonContent} from "@ionic/react";
import React, {useEffect, useState} from "react";
import {Form, FormGroup} from "reactstrap";
import DragDropFile from "../../../../Components/DragDropFile";
import ButtonWithSpinner from "../../../../Components/ButtonWithSpinner";
import {
  importNewContactsRequestStart, importNewContactsToggleModal, importNewContactsTouchForm,
} from "../../../../actions/Chats";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";



const ChatsWrapper = (
    {


        importNewContactsTouchForm,
        importNewContactsStateModal,
        importNewContactsToggleModal,
        importNewContactsRequestStart,
        importNewContactsErrors,
        importNewContactsLoading,
    }
) => {
    const {t, i18n} = useTranslation();

    // State


    // --------------------------
    // Hooks
    // --------------------------
    // componentDidMount && componentWillUnmount



    const [importNewContactsFile, setImportNewContactsFile] = useState('');

    useEffect(() => {
        if (!importNewContactsStateModal) {
            setImportNewContactsFile('');
            importNewContactsTouchForm();
        }
    }, [importNewContactsStateModal]);

    const sendImportNewContactsRequest = (e) => {
        e.preventDefault();
        importNewContactsRequestStart(importNewContactsFile.file);
    }

    return <WrapperIonModal
        isOpen={importNewContactsStateModal}
        toggle={importNewContactsToggleModal}
        title={t('chats.modal_import_new_contacts.import_new_contacts', "Import new contacts")}>
        <Form onSubmit={sendImportNewContactsRequest} autoComplete="on" className="p-2">
            <FormGroup>
                <DragDropFile
                    handleChange={setImportNewContactsFile}
                    handleClick={importNewContactsTouchForm}
                    title={t('chats.modal_import_new_contacts.to_add_a_file', "To add a file")}
                    fileTypes={["text/csv"]}/>
            </FormGroup>
            <div
                className="text-center mt-3 mb-3">{t('chats.modal_import_new_contacts.import_new_contacts_description', "Import new contacts description")}</div>
            <div className="mt-4">
                <ButtonWithSpinner title={t('chats.modal_import_new_contacts.upload', "Upload")}
                                   type="submit" loading={importNewContactsLoading}
                                   disabled={!importNewContactsFile.file || importNewContactsFile.fileType !== "text/csv"}/>
            </div>
            <div className="text-center text-danger mt-3">{get(importNewContactsErrors, 'common')}</div>
            <div className="text-danger mr-3 mt-3">{get(importNewContactsErrors, 'phone_invalid')}</div>
        </Form>
    </WrapperIonModal>
}

const mapStateToProps = state => ({

    importNewContactsStateModal: state.Chats.importNewContactsStateModal,
    importNewContactsErrors: state.Chats.importNewContactsErrors,
    importNewContactsLoading: state.Chats.importNewContactsLoading,
});

const mapDispatchToProps = dispatch => ({
    importNewContactsTouchForm: () => dispatch(importNewContactsTouchForm()),
    importNewContactsToggleModal: (bool) => dispatch(importNewContactsToggleModal(bool)),
    importNewContactsRequestStart: (file) => dispatch(importNewContactsRequestStart(file)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatsWrapper);
